// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instruction_header__woSCc {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 4fr;
}

.instruction_header_block__n6iOz {
  font-family: "Rubik Mono One";
  text-stroke: 1px #3FA449;
  -webkit-text-stroke: 1px #3FA449;
}

.instruction_header_back__BtGUN {
  display: none;
}

.instruction_content__D8Lks {
  margin-top: 50px;
}

.instruction_content_block__Yr-Cw {
  border-radius: 25px;
  background-color: #CCFFD1;
  padding: 48px 110px;
  margin: 20px 150px;
  border: 2px solid #7EDB88;
}

.instruction_screenshot__kUboM {
  display: flex;
  justify-content: center;
  position: relative;
}
.instruction_screenshot__kUboM img {
  width: 100%;
}

.instruction_white_block__P-kyU {
  background-color: white;
  border-radius: 11px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 100px;
  margin-top: 20px;
  font-family: Rubik, serif;
  font-weight: 300;
  color: #2F2F2F;
}
.instruction_white_block__P-kyU h2 {
  text-align: center;
  font-size: 20px;
  line-height: 24px;
}

.instruction_schedule__5s0II {
  width: 100%;
  margin-top: 20px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
}

.instruction_green_block__N9Q74 {
  margin-top: 20px;
  border-radius: 20px;
  background-color: #7EDB88;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 55px 0;
}

.instruction_white_block_info__MB\\+TM {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  margin-top: 20px;
  gap: 20px;
}
.instruction_white_block_info__MB\\+TM p {
  font-weight: 400;
}

.instruction_point__D38tS {
  display: flex;
}

.instruction_white_block_round__S32Qp {
  color: white;
  border-radius: 50%;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  padding: 1px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  width: 22px;
  height: 22px;
}

.instruction_white_block_round_green__BBrLE {
  background-color: #2FD414;
}

.instruction_white_block_round_red__qmwzx {
  background-color: #F8521D;
}

.instruction_white_block_round_orange__WBGgX {
  background-color: #F8861D;
}

.instruction_white_block_round_lightred__Vrekn {
  background-color: #D45757;
}

.instruction_white_block_round_purple__1fQP5 {
  background-color: #DB7ECC;
}

.instruction_screenshot_round__JdraR {
  font-weight: bold;
  position: absolute;
  color: white;
  border-radius: 50%;
  font-size: 16px;
  line-height: 20px;
  width: 32px;
  height: 32px;
  padding: 6px 11px;
}

.instruction_screenshot_round_red1__JC4We {
  background-color: #F8521D;
  right: 18%;
  top: 27%;
}

.instruction_screenshot_round_red2__RcZ9g {
  background-color: #F8521D;
  left: 4%;
  top: 8%;
}

.instruction_screenshot_round_red3__u3ZHr {
  background-color: #F8521D;
  left: 11%;
  top: 35%;
}

.instruction_screenshot_round_red4__OUl9H {
  background-color: #F8521D;
  left: 45%;
  top: 15%;
}

.instruction_screenshot_round_red5__U50Y9 {
  background-color: #F8521D;
  left: 25%;
  top: 55%;
}

.instruction_screenshot_round_green1__eNTpX {
  background-color: #2FD414;
  left: 4%;
  top: 8%;
}

.instruction_screenshot_round_green2__Owz8- {
  background-color: #2FD414;
  left: 4%;
  bottom: 22%;
}

.instruction_screenshot_round_orange1__UG1Yj {
  background-color: #F8861D;
  left: 45%;
  top: 17%;
}

.instruction_screenshot_round_orange2__a2681 {
  background-color: #F8861D;
  left: 34%;
  top: 19%;
}

.instruction_screenshot_round_orange3__DVCJT {
  background-color: #F8861D;
  right: 19%;
  top: 52%;
}

.instruction_screenshot_round_orange4__3MdAv {
  background-color: #F8861D;
  right: 19%;
  top: 57%;
}

.instruction_screenshot_round_orange5__94N5F {
  background-color: #F8861D;
  right: 36%;
  bottom: 5%;
}

.instruction_screenshot_round_lightred1__wtKh- {
  background-color: #D45757;
  top: 0;
  right: 35%;
}

.instruction_screenshot_round_purple1__v-Gmt {
  background-color: #DB7ECC;
  top: 19%;
  right: 48%;
}

@media screen and (max-width: 1350px) {
  .instruction_content_block__Yr-Cw {
    padding: 48px 70px;
  }
}
@media screen and (max-width: 1024px) {
  .instruction_content_block__Yr-Cw {
    margin: 20px 0;
  }
  .instruction_header__woSCc {
    grid-template-columns: 1fr;
  }
  .instruction_header_back__BtGUN {
    padding: 0;
    display: block;
  }
  .instruction_header_back__BtGUN img {
    height: 100%;
  }
  .instruction_header_block__n6iOz {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .instruction_back_button__\\+5jly {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .instruction_content_block__Yr-Cw {
    padding: 20px;
  }
  .instruction_white_block__P-kyU {
    padding: 20px;
  }
}
@media screen and (max-width: 600px) {
  .instruction_content__D8Lks {
    margin-top: 0;
  }
  .instruction_content_block__Yr-Cw {
    padding: 16px;
  }
  .instruction_screenshot_round__JdraR {
    font-size: 12px;
    line-height: 14px;
    padding: 1px 4.5px;
    width: 16px;
    height: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/instruction/instruction.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AACF;;AAEA;EACE,6BAAA;EACA,wBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;AAEJ;;AAEA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;AACF;AAAE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;AACF;AAAE;EACE,gBAAA;AAEJ;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,UAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,QAAA;EACA,OAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,QAAA;EACA,OAAA;AACF;;AAEA;EACE,yBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,UAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,UAAA;EACA,QAAA;AACF;;AAEA;EACE,yBAAA;EACA,UAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,MAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,QAAA;EACA,UAAA;AACF;;AAGA;EACE;IACE,kBAAA;EAAF;AACF;AAGA;EAKE;IACE,cAAA;EALF;EAQA;IACE,0BAAA;EANF;EASA;IACE,UAAA;IACA,cAAA;EAPF;EAQE;IACE,YAAA;EANJ;EAUA;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;EARF;EAWA;IACE,aAAA;EATF;AACF;AAYA;EACE;IACE,aAAA;EAVF;EAaA;IACE,aAAA;EAXF;AACF;AAcA;EAEE;IACE,aAAA;EAbF;EAgBA;IACE,aAAA;EAdF;EAiBA;IACE,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;EAfF;AACF","sourcesContent":[".header {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: 1fr 4fr;\n}\n\n.header_block {\n  font-family: 'Rubik Mono One';\n  text-stroke: 1px #3FA449;\n  -webkit-text-stroke: 1px #3FA449;\n}\n\n.header_back {\n  display: none;\n}\n\n.content {\n  margin-top: 50px;\n}\n\n.content_block {\n  border-radius: 25px;\n  background-color: #CCFFD1;\n  padding: 48px 110px;\n  margin: 20px 150px;\n  border: 2px solid #7EDB88;\n}\n\n.screenshot {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  img {\n    width: 100%;\n  }\n}\n\n.white_block {\n  background-color: white;\n  border-radius: 11px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 20px 100px;\n  margin-top: 20px;\n  font-family: Rubik, serif;\n  font-weight: 300;\n  color: #2F2F2F;\n  h2 {\n    text-align: center;\n    font-size: 20px;\n    line-height: 24px;\n  }\n}\n\n.schedule {\n  width: 100%;\n  margin-top: 20px;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 400;\n}\n\n.green_block {\n  margin-top: 20px;\n  border-radius: 20px;\n  background-color: #7EDB88;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 55px 0;\n}\n\n.white_block_info {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 20px;\n  padding: 20px;\n  margin-top: 20px;\n  gap: 20px;\n  p {\n    font-weight: 400;\n  }\n}\n\n.point {\n  display: flex;\n}\n\n.white_block_round {\n  color: white;\n  border-radius: 50%;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: bold;\n  padding: 1px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 20px;\n  width: 22px;\n  height: 22px;\n}\n\n.white_block_round_green {\n  background-color: #2FD414;\n}\n\n.white_block_round_red {\n  background-color: #F8521D;\n}\n\n.white_block_round_orange {\n  background-color: #F8861D;\n}\n\n.white_block_round_lightred {\n  background-color: #D45757;\n}\n\n.white_block_round_purple {\n  background-color: #DB7ECC;\n}\n\n.screenshot_round {\n  font-weight: bold;\n  position: absolute;\n  color: white;\n  border-radius: 50%;\n  font-size: 16px;\n  line-height: 20px;\n  width: 32px;\n  height: 32px;\n  padding: 6px 11px;\n}\n\n.screenshot_round_red1 {\n  background-color: #F8521D;\n  right: 18%;\n  top: 27%;\n}\n\n.screenshot_round_red2 {\n  background-color: #F8521D;\n  left: 4%;\n  top: 8%;\n}\n\n.screenshot_round_red3 {\n  background-color: #F8521D;\n  left: 11%;\n  top: 35%;\n}\n\n.screenshot_round_red4 {\n  background-color: #F8521D;\n  left: 45%;\n  top: 15%;\n}\n\n.screenshot_round_red5 {\n  background-color: #F8521D;\n  left: 25%;\n  top: 55%;\n}\n\n.screenshot_round_green1 {\n  background-color: #2FD414;\n  left: 4%;\n  top: 8%;\n}\n\n.screenshot_round_green2 {\n  background-color: #2FD414;\n  left: 4%;\n  bottom: 22%;\n}\n\n.screenshot_round_orange1 {\n  background-color: #F8861D;\n  left: 45%;\n  top: 17%;\n}\n\n.screenshot_round_orange2 {\n  background-color: #F8861D;\n  left: 34%;\n  top: 19%;\n}\n\n.screenshot_round_orange3 {\n  background-color: #F8861D;\n  right: 19%;\n  top: 52%;\n}\n\n.screenshot_round_orange4 {\n  background-color: #F8861D;\n  right: 19%;\n  top: 57%;\n}\n\n.screenshot_round_orange5 {\n  background-color: #F8861D;\n  right: 36%;\n  bottom: 5%;\n}\n\n.screenshot_round_lightred1 {\n  background-color: #D45757;\n  top: 0;\n  right: 35%;\n}\n\n.screenshot_round_purple1 {\n  background-color: #DB7ECC;\n  top: 19%;\n  right: 48%;\n}\n\n\n@media screen and (max-width: 1350px) {\n  .content_block {\n    padding: 48px 70px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n\n  .content {\n  }\n\n  .content_block {\n    margin: 20px 0;\n  }\n\n  .header {\n    grid-template-columns: 1fr;\n  }\n\n  .header_back {\n    padding: 0;\n    display: block;\n    img {\n      height: 100%;\n    }\n  }\n\n  .header_block {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .back_button {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .content_block {\n    padding: 20px;\n  }\n\n  .white_block {\n    padding: 20px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .content {\n    margin-top: 0;\n  }\n\n  .content_block {\n    padding: 16px;\n  }\n\n  .screenshot_round {\n    font-size: 12px;\n    line-height: 14px;\n    padding: 1px 4.5px;\n    width: 16px;\n    height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `instruction_header__woSCc`,
	"header_block": `instruction_header_block__n6iOz`,
	"header_back": `instruction_header_back__BtGUN`,
	"content": `instruction_content__D8Lks`,
	"content_block": `instruction_content_block__Yr-Cw`,
	"screenshot": `instruction_screenshot__kUboM`,
	"white_block": `instruction_white_block__P-kyU`,
	"schedule": `instruction_schedule__5s0II`,
	"green_block": `instruction_green_block__N9Q74`,
	"white_block_info": `instruction_white_block_info__MB+TM`,
	"point": `instruction_point__D38tS`,
	"white_block_round": `instruction_white_block_round__S32Qp`,
	"white_block_round_green": `instruction_white_block_round_green__BBrLE`,
	"white_block_round_red": `instruction_white_block_round_red__qmwzx`,
	"white_block_round_orange": `instruction_white_block_round_orange__WBGgX`,
	"white_block_round_lightred": `instruction_white_block_round_lightred__Vrekn`,
	"white_block_round_purple": `instruction_white_block_round_purple__1fQP5`,
	"screenshot_round": `instruction_screenshot_round__JdraR`,
	"screenshot_round_red1": `instruction_screenshot_round_red1__JC4We`,
	"screenshot_round_red2": `instruction_screenshot_round_red2__RcZ9g`,
	"screenshot_round_red3": `instruction_screenshot_round_red3__u3ZHr`,
	"screenshot_round_red4": `instruction_screenshot_round_red4__OUl9H`,
	"screenshot_round_red5": `instruction_screenshot_round_red5__U50Y9`,
	"screenshot_round_green1": `instruction_screenshot_round_green1__eNTpX`,
	"screenshot_round_green2": `instruction_screenshot_round_green2__Owz8-`,
	"screenshot_round_orange1": `instruction_screenshot_round_orange1__UG1Yj`,
	"screenshot_round_orange2": `instruction_screenshot_round_orange2__a2681`,
	"screenshot_round_orange3": `instruction_screenshot_round_orange3__DVCJT`,
	"screenshot_round_orange4": `instruction_screenshot_round_orange4__3MdAv`,
	"screenshot_round_orange5": `instruction_screenshot_round_orange5__94N5F`,
	"screenshot_round_lightred1": `instruction_screenshot_round_lightred1__wtKh-`,
	"screenshot_round_purple1": `instruction_screenshot_round_purple1__v-Gmt`,
	"back_button": `instruction_back_button__+5jly`
};
export default ___CSS_LOADER_EXPORT___;
